import { LocaleKey } from 'helpers/languages/translations';
import { IVisibleKeyword } from 'types';

export const KEYWORDS_COLUMNS: { id: keyof IVisibleKeyword; name: LocaleKey; banner: boolean; search: boolean }[] = [
    { id: 'name', name: 'keyword.column.keyword', banner: true, search: true },
    { id: 'type', name: 'keyword.column.type', banner: true, search: true },
    { id: 'language', name: 'keyword.column.language', banner: true, search: true },
    { id: 'master', name: 'keyword.column.master', banner: true, search: true },
    { id: 'priority', name: 'keyword.column.criticality', banner: true, search: true },
    { id: 'for_int_scorecard', name: 'keyword.column.intScorecard', banner: false, search: true },
];

export const EMPTY_KEYWORD: IVisibleKeyword = {
    name: '',
    type: '',
    language: 'fr',
    master: 1,
    priority: 1,
    for_int_scorecard: false,
};

export const EMPTY_PARTIAL_KEYWORD: IVisibleKeyword = {
    name: '',
    type: '',
    language: 'fr',
    priority: 1,
    master: 1,
};
